export namespace CustomDropDown {

    export interface IDropDown {
        source: any[];
        selectedValue: any;
        defaultSelectedValue: any;
        label: string;
        objectName: string;
        onSelectedValueChangedCallback: (value: any, objectName: any, listName: string, identifier: any) => void;
        onQuerySearch?: (query: any) => Promise<any>;
        StateGetter?: () => any;
        setInstanceToParent: boolean;
        setInstanceToParentCallback: (ref: any) => void;

        valueField: string;
        textField: string;

        isSelect: boolean;
        isAutoComplete: boolean;
        sourceUrl: string | null;

        isMultiple: boolean;
        useChips: boolean;
        useTags: boolean;
        isClearable: boolean;
        isPropWatcherEnable: boolean;
        onBlurCallback: () => void;

        listVariableName: string;
        isDisabled?: () => boolean;

        onClearCallback: () => any;
        IsStateApplied: () => any;

        showLoading: boolean;
        closeOnClickIfEmpty: boolean;
        autoCompleteMinLength: number;
        //For the implementation of asterisk
        isRequired: boolean;
        allowStringValue: boolean;

        filter: (item: any, queryText: any, itemText: any) => boolean;
        dropdownIcon: string;
        hideChipsInDropdown: boolean;
        numberOfChipsToShow: number;
        clearTextOnBlur: boolean;
        filterChipsInDropdown: boolean;
        showAllChip: boolean;
        customSelectedText: string;
        isProduct: boolean;
        onKeyDownCallback: (event: KeyboardEvent) => void;
        useAttachProperty: boolean;
        identifier: any;
        customClasses: string;
        isAssetsFrom: boolean;
        autoSelectFirst: boolean;
        customId: string;
        contactsFromAllClients: boolean;
        onAllClientsSelectedCallback: () => void;
        isOutlined: boolean;
        placeholder: string;
        isDescriptionAllow: boolean;
    }

    export class DropDown implements IDropDown {
        public source: any[];
        public selectedValue: any;
        public defaultSelectedValue: any;
        public label: string;
        public objectName: string;
        public onSelectedValueChangedCallback: (value: any, objectName: any, listName: string, identifier: any) => void;
        public onQuerySearch?: (query: any) => Promise<any>;
        public StateGetter?: () => any;
        public isDisabled?: () => boolean;

        public setInstanceToParent: boolean = false;
        public setInstanceToParentCallback: (ref: any) => void;

        // optional fields
        public valueField: string = 'id';
        public textField: string = 'name';

        public isSelect: boolean = false;
        public isAutoComplete: boolean = false;
        public sourceUrl: string | null = null;

        public isMultiple: boolean = false;
        public useChips: boolean = false;
        public useTags: boolean = false;
        public isPropWatcherEnable: boolean = false;
        public isClearable: boolean = true;
        public onBlurCallback: () => void;
        public IsStateApplied: () => any;

        public listVariableName: string = '';

        public onClearCallback!: () => any;
        public showLoading: boolean = false;
        public closeOnClickIfEmpty: boolean = false;
        public isRequired: boolean = false;
        public autoCompleteMinLength: number = 1;
        public allowStringValue: boolean = false;

        public filter!: (item: any, queryText: any, itemText: any) => boolean;
        public dropdownIcon: string = '$dropdown';
        public hideChipsInDropdown: boolean = false;
        public clearTextOnBlur: boolean = true;
        public filterChipsInDropdown: boolean = false;
        public showAllChip: boolean = false;
        public customSelectedText: string = '';
        public isProduct: boolean = false;
        public numberOfChipsToShow: number = 1;
        onKeyDownCallback!: (event: KeyboardEvent) => void;
        public useAttachProperty: boolean = false;
        public identifier: any;
        public customClasses: string = '';
        public isAssetsFrom: boolean = false;
        public autoSelectFirst: boolean = false;
        public customId: string = '';
        public contactsFromAllClients: boolean = false;
        public onAllClientsSelectedCallback!: () => void;
        public isOutlined: boolean = false;
        public placeholder: string = "";
        public isDescriptionAllow: boolean = false;


        public constructor(source: any[], selectedValue: any, defaultSelectedValue: any,
            label: string, objectName: string, onSelectedValueChangedCallback: any,

            setInstanceToParent: boolean = false, setInstanceToParentCallback: any = null,

            valueField: string = 'id', textField: string = 'name',

            isSelect: boolean = false,
            isAutoComplete: boolean = false, sourceUrl: string | null = null,
            isMultiple: boolean = false, useChips: boolean = false,
            useTags: boolean = false, isClearable: boolean = true,
            onBlurCallback: any = null,
            listVariableName: string = '',
            isDisabled: boolean = false,
            isPropWatcherEnable: boolean = false, autoCompleteMinLength: number = 1
        ) {
            this.isPropWatcherEnable = isPropWatcherEnable;
            this.source = source;
            this.selectedValue = selectedValue;
            this.defaultSelectedValue = defaultSelectedValue;
            this.label = label;
            this.objectName = objectName;


            this.valueField = valueField;
            this.textField = textField;
            this.isSelect = isSelect;
            this.isAutoComplete = isAutoComplete;
            this.sourceUrl = sourceUrl;
            this.isMultiple = isMultiple;
            this.useChips = useChips;
            this.useTags = useTags;
            this.isClearable = isSelect == false && isClearable;
            this.listVariableName = listVariableName;

            this.setInstanceToParent = setInstanceToParent;
            this.setInstanceToParentCallback = setInstanceToParentCallback;
            this.onSelectedValueChangedCallback = onSelectedValueChangedCallback;
            this.onBlurCallback = onBlurCallback;
            this.autoCompleteMinLength = autoCompleteMinLength;


            this.IsStateApplied = () => typeof this.StateGetter !== "undefined";
        }
    }
}
